<template>
    <b-modal
        v-model="modal"
        :title="$t('group.internship.messages')"
        ok-only
        :ok-title="$t('common.close')"
        modal-class="apprentice-default-modal project-show-message-modal"
        size="md"
        :no-enforce-focus="true">
        <design-2021-project-show-message-component
            :project-type-id="project_id"
            :messages-in="messages"
            message-type="project"
            :widget-mode="true"
            :is-student="$authUser.isStudent()">
        </design-2021-project-show-message-component>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-project-message-modal-component',
    data() {
        return {
            project_id: null,
            modal: false,
            messages: [],
        };
    },
    methods: {
        show(project_id) {
            if (this.project_id === project_id) {
                this.modal = true;
                return;
            }

            this.messages = [];
            this.alert.loading();
            this.axios.get(this.routes.projectMessages(project_id)).then(
                (response) => {
                    this.messages = response.data;
                    this.alert.close();
                    this.project_id = project_id;
                    this.modal = true;
                    this.resetUnreadMessages(project_id);
                },
                (error) => {
                    this.alert.ajaxError;
                },
            );
        },
        resetUnreadMessages(project_id) {
            this.axios.delete(this.routes.projectDeleteUnreadMessage(project_id)).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
